<script setup lang="ts">
import NavItem from './component/NavItem.vue';
import { navOptions } from '@layouts/constant';
const route = useRoute();

const navDisplayResult = computed(() =>
    navOptions.map(({ icon, activeIcon, href, ...rest }) => {
        const active = href === route.path;
        return {
            icon: active ? activeIcon : icon,
            color: active ? 'var(--blue-400)' : 'var(--cool-gray-700)',
            weight: (active ? '700' : '500') as FontWeights,
            to: href,
            ...rest,
        };
    })
);
const bottom = useViewPortBottom();
</script>

<template>
    <nav class="mobile-nav mobile remove-nav animate">
        <NavItem
            v-for="{
                label,
                icon,
                weight,
                to,
                color,
                ...rest
            } in navDisplayResult"
            :key="label"
            :icon
            :weight
            :color
            :label
            :to
            @click="rest?.onClick"
        />
    </nav>
</template>

<style scoped lang="scss">
:global(body) {
    padding-bottom: 65px;
}

.remove-mobile-nav {
    .remove-nav {
        display: none !important;
    }
}

.mobile {
    @include desktop-only {
        display: none !important;
    }
}
.mobile-nav {
    display: flex;
    position: fixed;
    bottom: v-bind(bottom);
    right: 0;
    left: 0;
    background-color: white;
    z-index: 1002;
    @include shadow(3);
    overflow: hidden;
    padding-bottom: env(safe-area-inset-bottom);
}

// can add this to the bill later on
.animate {
    transition: bottom 0.25s ease;
    transition: bottom 0.25s ease; /* smooth movement */
    will-change: bottom; /* hint for performance */
}
</style>
